export const dialogWidth = {
  data() {
    return {
      dialogWidth:
        window.innerWidth > 768
          ? window.innerWidth > 992
            ? window.innerWidth > 1200
              ? "60%"
              : "80%"
            : "90%"
          : "100%",
      largeDialogWidth:
        window.innerWidth > 992
          ? window.innerWidth > 1200
            ? "70%"
            : "80%"
          : "100%"
    };
  },
  methods: {
    onResize() {
      if (window.innerWidth < 768) {
        this.dialogWidth = "100%";
      } else if (window.innerWidth < 992) {
        this.dialogWidth = "90%";
        this.largeDialogWidth = "100%";
      } else if (window.innerWidth < 1200) {
        this.dialogWidth = "80%";
        this.largeDialogWidth = "80%";
      } else {
        this.dialogWidth = "60%";
        this.largeDialogWidth = "70%";
      }
    }
  }
};
